export const pricing = {
  seo: {
    title: 'Prijzen – vanaf €0 per maand | Bistroo',
    description: 'Geen opstartkosten. Kies een gratis module of betaald abonnement. Bekijk alle Bistroo-prijzen en start vandaag nog.',
  },
  hero: {
    heading: {
      serve: 'Wij bieden',
      flexible: 'flexibele prijzen',
      scales: 'die meegroeien',
    },
    choose: 'Stel een pakket samen dat het beste bij jouw restaurant past.',
    switch: 'Schakel tussen abonnementsprijzen en prijs per volume.',
    billing: {
      monthly: 'Maandelijks',
      yearly: 'Jaarlijks',
      badge: '20% korting',
      badge_short: '-20%',
    },
  },

  content: {
    build: {
      title: 'Stel je pakket samen',
      text: [
        {
          the: 'Het',
          first: 'eerste product kost €39',
          month: 'per maand.',
          additional: 'Elk extra product kost €15',
          added: 'per maand bovenop de basisprijs.',
        },
        {
          no: 'Geen maandelijks abonnement.',
          pay: 'Betaal alleen een fee over je orderwaarde.',
          all: 'Alle add-ons zijn gratis inbegrepen',
        },
      ],
      base: ['€ 39', '€ 0'],
      extra: ['€ 15', '€ 0'],
    },
    contact: {
      title: 'Neem contact op',
      text: 'Heb je eventueel nog vragen of behoefte aan maatwerk?',
      cta: 'Contact opnemen',
    },
    first: {
      title: ['Eerste product', 'Gratis producten & addons'],
      price: ['€ 39', '€ 0'],
      month: 'Maand',
    },
    toggle: {
      subscription: 'Abonnement',
      volumefee: 'Volume-fee',
    },
  },

  plans: {
    website: {
      title: 'Website',
      price: ['€ 15', '7%'],
      period: ['/ maand', '/ bestelling'],
      subtitle: 'Webshop of website',
      description:
        'Professionele horeca-website, goed vindbaar in Google en geintegreerd met jouw Bistroo webshop',
      enabledFeatures: [
        'Inclusief Webshop',
        'Responsive design in eigen huisstijl',
        'SEO & Google optimalisatie',
        'Inc. Hosting, onderhoud en back-ups',
        'Eigen beheer via de Bistroo Manager',
      ],
      start: 'Start gratis',
    },
    webshop: {
      title: 'Webshop',
      price: ['€ 15', '7%'],
      period: ['/ maand', '/ bestelling'],
      subtitle: 'Webshop of QR',
      description:
        'Complete online shop voor afhalen en bezorgen in je eigen huisstijl volledig geïntegreerd met jouw website',
      enabledFeatures: [
        'Interactief menu met upsell-opties',
        'Tijdsloten en capaciteitsbeheer',
        'Bezorg-zones intekenen op kaart',
        'Alle relevante betaalmethoden',
        'Eigen beheer via de Bistroo Manager',
      ],
      start: 'Start gratis',
    },
    pos: {
      title: 'Kassa',
      price: ['€ 15', '1,49%'],
      period: ['/ maand', '/ bestelling'],
      subtitle: 'Webshop en website',
      description:
        'Supersnelle kassa, ontwikkeld voor quick-service restaurants. Bestellen en afrekenen in één handomdraai',
      enabledFeatures: [
        'Plug-and-play kassasysteem',
        'Snelle orderinvoer met opties',
        'Keuken- en klantenbonnen',
        'PIN, contactloos en split-payments',
        'Shift- en dagafsluiting met Z-rapport',
        'Eigen beheer via de Bistroo Manager',
      ],
      start: 'Vraag aan',
    },
    kiosk: {
      title: 'Kiosk',
      price: ['€ 15', '1,49%'],
      period: ['/ maand', '/ bestelling'],
      subtitle: 'Webshop en website',
      description:
        'Self-service bestelzuil. Kortere rijen, consistente upsell, hogere gemiddelde besteding',
      enabledFeatures: [
        'Interactief design in eigen huisstijl',
        'Eye-catcher en conversie verhogend',
        'Upsell- en cross-sell-suggesties',
        'Afronding met ordernummer en bon',
        'PIN, contactloos en mobile payments',
        'Eigen beheer via de Bistroo Manager',
      ],
      start: 'Vraag aan',
    },
    qr: {
      title: 'QR',
      price: ['€ 15', '3,49%'],
      period: ['/ maand', '/ bestelling'],
      subtitle: 'Webshop en website',
      description:
        'Laat gasten zelf bestellen en betalen. Minder wachttijd, meer rondes, hogere gemiddelde bon',
      enabledFeatures: [
        'Direct bestellen & betalen aan tafel',
        'Interactief menu met upsell-opties',
        "Tafelgebonden QR's",
        'Fooi-optie',
        'Eigen beheer via de Bistroo Manager',
      ],
      start: 'Start gratis',
    },
    enterprise: {
      title: 'Enterprise',
      price: ['Op maat', 'Op maat'],
      period: ['prijs', 'prijs'],
      subtitle: 'Stel je pakket samen',
      description:
        'Maatwerkoplossingen voor ketens en grotere restaurants met meerdere vestigingen',
      enabledFeatures: [
        'Maatwerk-aanbod',
        'Automatische afdracht en facturatie',
        'Persoonlijk aanspreekpunt',
        'Beheer van meerdere locaties',
        'Enterprise Bistroo Manager',
      ],
      start: 'Neem contact op',
    },
  },
}
